import _slicedToArray from "/Users/lacassiano.sugiyama/Workspace/peloton/git/web-tv/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/slicedToArray.js";
import { ApiEnvs } from '@peloton/external-links/models';
import parseHostname from './parseHostname';

var toApiEnv = function toApiEnv(hostname, _ref) {
  var isProd = _ref.isProd,
      isUatProd = _ref.isUatProd;

  var _parseHostname = parseHostname(hostname),
      api = _parseHostname.api;

  if (api) {
    if (api === 'local') {
      return ApiEnvs.Local;
    } else if (api === 'qa1') {
      return ApiEnvs.Qa1;
    } else if (api === 'qa2') {
      return ApiEnvs.Qa2;
    } else if (api === 'api') {
      return ApiEnvs.Prod;
    }

    return toKubernetesApi(api);
  }

  if (isProd || isUatProd) {
    return ApiEnvs.Prod;
  }

  if (hostname.indexOf('qa2-www') === 0) {
    return ApiEnvs.Qa2;
  }

  var REACT_APP_API_ENV = process.env.REACT_APP_API_ENV;
  return REACT_APP_API_ENV && ApiEnvs[REACT_APP_API_ENV] || ApiEnvs.Qa1;
};

export default toApiEnv;
export var toKubernetesApi = function toKubernetesApi(api) {
  var _api$replace$split = api.replace('k8s--', '').split('--'),
      _api$replace$split2 = _slicedToArray(_api$replace$split, 2),
      namespace = _api$replace$split2[0],
      _api$replace$split2$ = _api$replace$split2[1],
      cluster = _api$replace$split2$ === void 0 ? 'dev' : _api$replace$split2$;

  if (cluster === 'test') {
    return "api.".concat(namespace, ".").concat(cluster, ".k8s");
  }

  return "api-".concat(namespace, ".").concat(cluster, ".k8s");
};